export default "__VITE_ASSET__BVDYhwNx__"